selectDetailDisplayType